import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import {useEffect,useState} from "react"
const ProtectedRouteForLogin = () => {

const [redirectToDashboard, setRedirectToDashboard] = useState(null);
useEffect(() => {
     const checkAuth = async () => {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/nft-token-gating-dashboard`, {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          setRedirectToDashboard(true)
        })
        .catch((err) => {
          setRedirectToDashboard(false)
          localStorage.removeItem("token");
        });
    };
    checkAuth();
  }, []);

  
if (redirectToDashboard) {
  return <Navigate to="/token-gating" />;
} else if(redirectToDashboard===false) { 
  return <Outlet />;
}
};

export default ProtectedRouteForLogin;
